import React from 'react';

import moment from 'moment';

import {
  GetFluxNextExecutionTimeResponseDtoFluxTypeEnum,
  SearchAlienationRecuperationEtatBienFluxDto,
} from 'lib_api/lib/api/gen';

import { ColumnProps } from 'components/WrappedComponents/Table/types';
import { FluxDisplayName } from 'enums/flux/FluxDisplayName';
import { DATE_FORMAT } from 'utils/formats';

import DashboardFluxAlienation from '../shared/components/DashboardFluxAlienation';

import { FluxVenteDossiersSortType } from './types';
import { useSearchFluxsRecuperationEtatBien } from './utils';

function DashboardVenteDossiers(): React.ReactElement {
  function buildColumns(): ColumnProps<
    SearchAlienationRecuperationEtatBienFluxDto,
    FluxVenteDossiersSortType
  >[] {
    return [
      {
        title: 'Début plage',
        buildCellContent: data => moment(data.dateDebut).format(DATE_FORMAT),
        sortedField: 'DATE_DEBUT',
      },
      {
        title: 'Fin plage',
        buildCellContent: data => moment(data.dateFin).format(DATE_FORMAT),
        sortedField: 'DATE_FIN',
      },
    ];
  }

  return (
    <DashboardFluxAlienation
      useSearchFluxs={useSearchFluxsRecuperationEtatBien}
      buildSpecificTableColumns={buildColumns}
      tableTitle={FluxDisplayName.ALIENATION_ETAT_BIENS}
      fluxType={
        GetFluxNextExecutionTimeResponseDtoFluxTypeEnum.ALIENATION_UPDATE_STATUS_BIEN
      }
      keyPagination={'paginationFluxAlienationEtatBiens'}
    />
  );
}

export default DashboardVenteDossiers;
